export enum AppTheme {
  light = 'light',
  dark = 'dark',
}
